import { styled } from '@mui/material/styles';

/** 통화 코드 → 국기 이미지(public/icons/flags). 레거시 intranet.css `.national-flag.flag-{CODE}` 와 같은 원본 */
export const CURRENCY_FLAG_SRC: Readonly<Record<string, string>> = {
  KRW: '/icons/flags/krw.svg',
  JPY: '/icons/flags/jpy.svg',
  CNY: '/icons/flags/cny.svg',
  USD: '/icons/flags/usd.svg',
  HKD: '/icons/flags/hkd.png',
  TWD: '/icons/flags/twd.png',
  MOP: '/icons/flags/mop.png',
  EUR: '/icons/flags/eur.svg',
  GBP: '/icons/flags/gbp.svg',
};

const FlagBox = styled('span')({
  display: 'inline-block',
  flexShrink: 0,
  boxSizing: 'border-box',
  verticalAlign: 'middle',
  border: '1px solid var(--dk-line, #F3F5F7)',
  borderRadius: 2,
  backgroundColor: 'var(--dk-bg-subtle, #F3F5F7)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  backgroundPosition: 'center',
});

const LabelRoot = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
});

type CurrencyFlagProps = {
  currency: string;
  /** px. 기본 20(레거시 .national-flag), 선택 메뉴는 30 */
  size?: number;
  className?: string;
};

/** 국기 — 모르는 통화는 회색 빈 칸 */
export const CurrencyFlag = ({
  currency,
  size = 20,
  className,
}: CurrencyFlagProps) => {
  const src = CURRENCY_FLAG_SRC[currency];
  return (
    <FlagBox
      aria-hidden="true"
      className={['currency-flag', className].filter(Boolean).join(' ')}
      style={{
        width: size,
        height: size,
        backgroundImage: src ? `url('${src}')` : undefined,
      }}
    />
  );
};

/** 국기 + 통화 코드 */
export const CurrencyLabel = ({ currency }: { currency: string }) => (
  <LabelRoot className="currency-label">
    <CurrencyFlag currency={currency} />
    {currency}
  </LabelRoot>
);

export default CurrencyFlag;
